export const formatTime = (time: number) => {
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor((time % 3600) % 60).toLocaleString("en-US", {
    minimumIntegerDigits: 2,
  });

  return `${minutes}:${seconds}`;
};

export const bounds = (val: number, min: number, max: number) =>
  Math.min(Math.max(min, val), max);

export const isWebGlSupported = (() => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }

  try {
    const canvas = document.createElement("canvas");
    return (
      (!!window.WebGLRenderingContext || !!window.WebGL2RenderingContext) &&
      (canvas.getContext("webgl") ||
        canvas.getContext("experimental-webgl") ||
        canvas.getContext("webgl2"))
    );
  } catch (e) {
    return false;
  }
})();
